import { BrowserRouter, Route, Routes } from 'react-router-dom';

/* Section for "Component" imports */
import PrivateRoute      from './utils/PrivateRoute';
import CreateTravelClaim from './pages/Claims/CreateTravelClaim';
import PostBankDetails   from './pages/BankDetails/PostBankDetails';
import TravelClaim     from './pages/Claims/TravelClaim';
import TravelClaims    from './pages/Claims/TravelClaims';
import EditTravelClaim from './pages/Claims/EditTravelClaim';
import Completed    from './pages/Claims/Completed';
import Login        from './pages/Auth/Login';
import Events       from './pages/Admin/Events/Events';
import EventDetail  from './pages/Admin/Events/EventDetail';
import EventCreate  from './pages/Admin/Events/EventCreate';
import Contacts     from './pages/Admin/Contacts/Contacts';
import SiteHeader   from './pages/SiteHeader';
import SiteFooter   from './pages/SiteFooter';
import ConsolseSiteHeader from './pages/ConsoleSiteHeader';
import ConsoleSiteBar     from './pages/ConsoleSiteBar';

import Index       from './pages/Admin/Index';
import AdminLogin  from './pages/Auth/MsalLogin';
import AdminClaims from './pages/Admin/Claims/TravelClaims';
import AdminClaim  from './pages/Admin/Claims/TravelClaim';
import DistanceBandOverview  from './pages/Admin/DistanceBandsOverview';
import DecisionTableCreate   from './pages/Admin/DecisionTables/DecisionTableCreate';
import DecisionTableEdit     from './pages/Admin/DecisionTables/DecisionTableEdit';
import CountryTablesOverview from './pages/Admin/CountryTables/CountryTablesOverview';
import CountryTableCreate    from './pages/Admin/CountryTables/CountryTableCreate';
import CountryTableEdit      from './pages/Admin/CountryTables/CountryTableEdit';

import AccommodationTablesOverview from './pages/Admin/AccommodationTables/AccommodationTablesOverview';
import AccommodationTableCreate    from './pages/Admin/AccommodationTables/AccommodationTableCreate';
import AccommodationTableEdit      from './pages/Admin/AccommodationTables/AccommodationTableEdit';

/* Section "CSS" imports */
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "react-tooltip/dist/react-tooltip.css";
import "./styles/era.css";
import "./styles/autocomplete.css";

/* MSAL imports */
import { AuthenticatedTemplate, MsalProvider, UnauthenticatedTemplate } from '@azure/msal-react';
import { msalClientApplication } from '.';

function App() {

    return (
        <div className="App d-flex flex-column">
            <MsalProvider instance={msalClientApplication}>
                <BrowserRouter>

                    <UnauthenticatedTemplate>
                        { /* Anonymous | Enduser Routes, Components and Headers  */ }
                        <SiteHeader />
                        <Routes>

                            { /* Protected Routes for securing unterlaying child components | Limit access to authenticated guest users */ }
                            <Route element={<PrivateRoute />}>
                                <Route path="/me/claims"                         Component={TravelClaims} />
                                <Route path="/me/claims/:guid"                   Component={TravelClaim} />
                                <Route path="/me/claims/:claimGuid/bankdetails/" Component={PostBankDetails} />
                                <Route path="/me/claims/edit/:guid"              Component={EditTravelClaim} />
                            </Route>

                            { /* Routes for Anonymous access */ }
                            <Route path="/claims/create/:eventNumber" Component={CreateTravelClaim} />
                            <Route path="/claims/completed"           Component={Completed} />
                            <Route path="/login"                      Component={Login} />
                            <Route path="/admin"                      Component={Index} />
                            <Route path="/admin/login"                Component={AdminLogin} />

                        </Routes>
                    </UnauthenticatedTemplate>

                    <AuthenticatedTemplate>
                        { /* Admin Console Routes, Components and Headers */ }
                        <ConsoleSiteBar>
                            <ConsolseSiteHeader />
                            <Routes>
                                <Route path="/admin/events"        Component={Events} />
                                <Route path="/admin/event/:id"     Component={EventDetail} />
                                <Route path="/admin/events/create" Component={EventCreate} />
                                <Route path="/admin/claims"        Component={AdminClaims} />
                                <Route path="/admin/claim/:guid"   Component={AdminClaim} />
                                <Route path="/admin/countries"          Component={CountryTablesOverview} />
                                <Route path="/admin/countries/create"   Component={CountryTableCreate} />
                                <Route path="/admin/countries/copy/:id" Component={CountryTableCreate} />
                                <Route path="/admin/countries/:id"    Component={CountryTableEdit} />
                                <Route path="/admin/distances"        Component={DistanceBandOverview} />
                                <Route path="/admin/tables/create"    Component={DecisionTableCreate} />
                                <Route path="/admin/tables/copy/:id"  Component={DecisionTableCreate} />
                                <Route path="/admin/tables/:id"       Component={DecisionTableEdit} />
                                <Route path="/admin/contacts"         Component={Contacts} />
                                <Route path="/admin/accommodations"          Component={AccommodationTablesOverview} />
                                <Route path="/admin/accommodations/create"   Component={AccommodationTableCreate} />
                                <Route path="/admin/accommodations/copy/:id" Component={AccommodationTableCreate} />
                                <Route path="/admin/accommodations/:id"      Component={AccommodationTableEdit} />
                            </Routes>
                        </ConsoleSiteBar>
                    </AuthenticatedTemplate>

                    <SiteFooter />

                </BrowserRouter>
              </MsalProvider>
          </div>
    );
}
export default App;